export default "__VITE_ASSET__BI$$XZfe__"